import React, { useState } from 'react';
import { Tab, TabsContainer } from './Tab.styles';
interface TabItem {
    title: string;
    value: string | object;
}

interface TabComponentProps {
    tabs: TabItem[];
    isDisabled?: boolean;
    onTabClick?: (value: string | object) => void;
}

const TabComponent: React.FC<TabComponentProps> = ({ tabs, isDisabled, onTabClick }) => {
    const [activeTab, setActiveTab] = useState<number>(0);

    const handleTabClick = (index: number) => {
        if (isDisabled) return;
        setActiveTab(index);
        onTabClick && onTabClick(tabs[index].value);
    };

    return (
        <>
            <TabsContainer active={activeTab === 0}>
                {tabs.map((tab, index) => (
                    <Tab
                        key={index}
                        active={activeTab === index}
                        isDisabled={isDisabled}
                        onClick={() => handleTabClick(index)}
                    >
                        {tab.title}
                    </Tab>
                ))}
            </TabsContainer>
        </>
    );
};

export default TabComponent;
